import { render, staticRenderFns } from "./MembershipEditor.vue?vue&type=template&id=1796cff0&scoped=true&"
import script from "./MembershipEditor.vue?vue&type=script&lang=js&"
export * from "./MembershipEditor.vue?vue&type=script&lang=js&"
import style0 from "./MembershipEditor.vue?vue&type=style&index=0&id=1796cff0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1796cff0",
  null
  
)

export default component.exports